// extracted by mini-css-extract-plugin
export var compactFilters = "_df-4";
export var detailImage = "_df-1";
export var dropdownContainer = "_df-2";
export var imageContainer = "_df-0";
export var selectedCard = "_df-3";